<template>
  <ContentWrapper>
    <main id="main" class="main pt-32 pb-20 tablet-landscape:pb-24 laptop:pb-30">
      <div class="text-center text-2xl font-headings my-12 font-bold">
        Terms of Service
      </div>
      <div class="blocks space-y-20 tablet-landscape:space-y-24 laptop:space-y-30">
        <section class="section sidebar-and-content-block relative">
          <div
            class="mx-auto w-full max-w-[calc(100vw-4rem)] tablet:max-w-[calc(100vw-6rem)] laptop:max-w-[67.5rem] relative space-y-6 tablet-landscape:space-y-8">
            <div
              class="grid grid-cols-4 gap-4 gap-y-6 tablet:grid-cols-8 tablet:gap-6 tablet-landscape:grid-cols-12 laptop:gap-8">
              <aside v-if="!loading && !error && sections.length"
                class="relative hidden tablet-landscape:col-span-3 tablet-landscape:block">
                <div class="bottom-auto transition-all duration-200 max-h-[calc(100%-32px)] space-y-4 static">
                  <h6 class="text-h6 tablet:text-h6-tablet laptop:text-h6-desktop font-bold">
                    Entegy Supply Terms
                  </h6>
                  <ul class="space-y-2">
                    <li v-for="section in sections" :key="section.id" class="relative pl-4">
                      <button type="button"
                        class="text-body-sm before:transition-all before:duration-100 before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:size-1.5 before:rounded-full hover:before:bg-dark"
                        :class="{ 'before:bg-dark': openSection === section.id }" @click="scrollToSection(section.id)">
                        {{ section.title }}
                      </button>
                    </li>
                  </ul>
                </div>
              </aside>
              <div class="col-span-full space-y-4"
                :class="loading || error || !sections.length ? 'tablet-landscape:col-span-12' : 'tablet-landscape:col-span-9'">
                <PolicyAccordionsBlock :sections="sections" :loading="loading" :error="error"
                  :open-section="openSection" @toggle="toggleSection" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  </ContentWrapper>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ContentWrapper from '../components/Layouts/ContentWrapper.vue'
import PolicyAccordionsBlock from '../components/Policy/PolicyAccordionsBlock.vue'

const sections = ref([])
const openSection = ref(null)
const loading = ref(true)
const error = ref(null)

onMounted(async () => {
  try {
    const response = await fetch('/terms-of-service.json')
    if (!response.ok) throw new Error('Failed to load terms of service')
    sections.value = await response.json()
  } catch (e) {
    error.value = e.message
  } finally {
    loading.value = false
  }
})

function toggleSection(id) {
  openSection.value = openSection.value === id ? null : id
}

function scrollToSection(id) {
  openSection.value = id
  const el = document.getElementById(`accordion-header-${id}`)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
</script>
